/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteDemoInput = {|
  id: string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type deleteDemoMutationVariables = {|
  input: DeleteDemoInput
|};
export type deleteDemoMutationResponse = {|
  +deleteDemo: ?{|
    +deletedDemoId: ?string
  |}
|};
export type deleteDemoMutation = {|
  variables: deleteDemoMutationVariables,
  response: deleteDemoMutationResponse,
|};
*/


/*
mutation deleteDemoMutation(
  $input: DeleteDemoInput!
) {
  deleteDemo(input: $input) {
    deletedDemoId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteDemoInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteDemoPayload",
    "kind": "LinkedField",
    "name": "deleteDemo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedDemoId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteDemoMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteDemoMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteDemoMutation",
    "operationKind": "mutation",
    "text": "mutation deleteDemoMutation(\n  $input: DeleteDemoInput!\n) {\n  deleteDemo(input: $input) {\n    deletedDemoId\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e320050ebacdeecdbf6b70346fedb922';

module.exports = node;
